var map = {
	"./active-btn.webp": 2512,
	"./angbao-bonus-thaipusam.webp": 2513,
	"./angbao-bonus.webp": 2514,
	"./angbao-bonus_dewali.webp": 2515,
	"./cny-lucky-draw.webp": 2516,
	"./cny-promo.webp": 2517,
	"./dewali-promo.webp": 2518,
	"./fifa-prediction.webp": 2519,
	"./fifa-qna.webp": 2520,
	"./raya-promo.webp": 2521,
	"./welcome-cny-bonus.webp": 2522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2511;